import { combineReducers } from 'redux';

import browseData from './browseData';
import dateSelection from './dateSelection';
import dealHunter from './dealHunter';
import departureTimeFilter from './departureTimeFilter';
import directnessFilter from './directnessFilter';
import hotelDateSelection from './hotelDateSelection';
import hotelsDatePrices from './hotelsDatePrices';
import initialSearchParams from './initialSearchParams';
import localisation from './localisation';
import michelinRecommendations from './michelinRecommendations';
import monthData from './monthData';
import route from './route';
import stay from './stay';
import ui from './ui';

export default combineReducers({
  directnessFilter,
  dateSelection,
  departureTimeFilter,
  hotelDateSelection,
  monthData,
  ui,
  browseData,
  localisation,
  michelinRecommendations,
  route,
  stay,
  hotelsDatePrices,
  initialSearchParams,
  dealHunter,
});
